export default __webpack_public_path__ + "static/media/instagram.c8d7ab81.svg";